import React, { useState } from 'react';

export default function SpotPuzzle({ data, onSolved }) {
  const [selected, setSelected] = useState([]);
  const [wrong, setWrong] = useState(false);

  const toggleItem = (name) => {
    setSelected((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };

  const handleSubmit = () => {
    const correctNames = data.items.filter((i) => i.correct).map((i) => i.name);
    const isCorrect =
      selected.length === correctNames.length &&
      selected.every((s) => correctNames.includes(s));

    if (isCorrect) {
      onSolved();
    } else {
      setWrong(true);
      setTimeout(() => setWrong(false), 1200);
    }
  };

  return (
    <div className="puzzle-spot">
      <p className="puzzle-prompt">{data.prompt}</p>
      <div className="spot-items">
        {data.items.map((item) => (
          <button
            key={item.name}
            className={`spot-item ${selected.includes(item.name) ? 'spot-selected' : ''}`}
            onClick={() => toggleItem(item.name)}
          >
            <span className="spot-emoji">{item.emoji}</span>
            <span className="spot-name">{item.name}</span>
          </button>
        ))}
      </div>
      {wrong && <p className="puzzle-wrong">Hmm, not quite right! 🤔</p>}
      <button className="puzzle-submit" onClick={handleSubmit}>That's my order!</button>
    </div>
  );
}
